import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/68/thumb-landscape.jpg"

const Post68 = ({ data: { allCategoryJson, postsJson }, location }) => {

  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>「産後、自分の服は二の次。でも本当はおしゃれをして出かけたい……」<br></br>
          「育休中で収入が限られているけれど、たまの外出では気分を上げたい」<br></br>
          「子供が小さいとバッグが汚れそうで、高いバッグを買う勇気が出ない」</p>
          <p>そんな悩みを抱えていませんか？実は今、ライフスタイルが激変する「産後・育休中」のママたちの間で、ブランドバッグのサブスク「ラクサス（Laxus）」が賢い選択肢として支持されています。</p>
          <p>今回は、育休中・産後のバッグ選びでラクサスが選ばれる理由と、現役ママユーザーが実際に選んでいる名品ブランドを解説します。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;「汚れたらどうしよう」の不安を解消する、安心のキズ・汚れ補償</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;買うよりお得？育休中の限られた期間に最適なサブスク活用</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;スマホ1つで完結！買い物に行く時間がないママを支える利便性</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;現役ママユーザーが選ぶ「産後の名品」人気トート3選</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>5 |</span>&nbsp;&nbsp;FAQ：育休中の利用に関するよくある質問</ScrollLink>
          </div>
        </p>
      </div>
      <section name="sec1" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/68/1.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>「汚れたらどうしよう」の不安を解消する、安心のキズ・汚れ補償</h2>
        </div>
        <p>育休中の外出は、ベビーカーへの接触や子供の食べこぼしなど、バッグが汚れるリスクと隣り合わせです。「高いバッグを買っても汚れるのが怖い」というママの悩みに、ラクサスは直接答えます。</p>
        <div className="mt4 bordered-box">
          <h3><span className="text-border-bottom">月額料金内の「キズ補償」で、産後のアクティブな外出をサポート</span></h3>
          <p>ラクサスでは、通常の使用範囲で発生するキズや汚れの修理費用をユーザーが負担する必要はありません。公園遊びや抱っこ紐での移動でも、過度に神経質にならずに憧れのバッグを「日常使い」できるのが最大のメリットです。</p>
        </div>
      </section>
      <section name="sec2" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/68/2.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>買うよりお得？育休中の限られた期間に最適なサブスク活用</h2>
        </div>
        <p>産後から復職までの数ヶ月〜1年強という期間は、荷物の量や移動手段が激変します。その時々で「必要なバッグの形」が変わるため、高額なバッグを購入するのはリスクが伴います。</p>
        <div className="mt4 bordered-box">
          <h3><span className="text-border-bottom">1日約180円で、ライフスタイルの変化に合わせてバッグを交換</span></h3>
          <p>お宮参りや結婚式にはフォーマルなハンドバッグ、普段の買い物には両手が空くショルダーバッグなど、育休中のシーンに合わせて自由に交換可能です。<br></br>
          使わない月は「利用停止（無料）」にできるため、家計に優しく賢いバッグ選びが叶います。</p>
        </div>
      </section>
      <section name="sec3" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/68/3.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>スマホ1つで完結！買い物に行く時間がないママを支える利便性</h2>
        </div>
        <p>赤ちゃん連れで百貨店へ行き、ゆっくりバッグを選ぶのは至難の業。ラクサスなら、授乳中や寝かしつけ後の隙間時間で、理想のバッグを見つけることができます。</p>
        <div className="mt4 bordered-box">
          <h3><span className="text-border-bottom">220万ダウンロード突破のアプリで、玄関先までお届け＆集荷（※2026年4月時点）</span></h3>
          <p>注文したバッグは最短当日発送で自宅に届き、返却も近くのコンビニや自宅への集荷依頼で完了します。<br></br>
          さらに<b className="text-font-bolder">往復送料無料</b>のため、追加コストを気にせず利用できるのも大きな魅力です。<br></br>
          「重い荷物を持って店舗へ行く」手間をゼロにできるのが、1分1秒を惜しむママたちに選ばれる理由です。</p>
        </div>
      </section>
      <section name="sec4" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/68/4.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>現役ママユーザーが選ぶ「産後の名品」人気トート3選</h2>
        </div>
        <p>「荷物が多いけれど、おしゃれも妥協したくない」というママたちが、実際にラクサスで予約して使っている、支持率の高い3大モデルです。</p>
        <div className="text-img-cloumn-main mt8">
          <figure>
            <StaticImage src="../../images/posts/68/5.jpg" alt="ゴヤール（GOYARD）サンルイGM"/>
          </figure>
          <div>
            <h3><span className="text-border-bottom">【ゴヤール（GOYARD）】サンルイGM</span></h3>
            <h4>【驚異の軽さと機能性】</h4>
            <p>荷物が多い産後、バッグ自体の重さを感じにくいのは本当に助かります。コーティングキャンバス素材は、雨の日や日常のふとした汚れにも比較的強く、気兼ねなく持ち出せる安心感が選ばれる理由です。</p>
          </div>
        </div>
        <div className="text-img-cloumn-main">
          <figure>
            <StaticImage src="../../images/posts/68/6.jpg" alt="エルメス（HERMÈS）ガーデン・パーティPM"/>
          </figure>
          <div>
            <h3><span className="text-border-bottom">【エルメス（HERMÈS）】ガーデン・パーティPM</span></h3>
            <h4>【気品あふれる大容量】</h4>
            <p>仕切りがないので、おむつポーチや着替えをスムーズに出し入れできます。カジュアルなキャンバス地でも、エルメスならではの品格があるため、お宮参りや1歳のお祝いなど、少しかしこまった場でも安心して使えます。</p>
          </div>
        </div>
        <div className="text-img-cloumn-main">
          <figure>
            <StaticImage src="../../images/posts/68/7.jpg" alt="ルイ・ヴィトン（LOUIS VUITTON）ネヴァーフル GM"/>
          </figure>
          <div>
            <h3><span className="text-border-bottom">【ルイ・ヴィトン（LOUIS VUITTON）】ネヴァーフル GM</span></h3>
            <h4>【圧倒的な耐久性】</h4>
            <p>「Never Full＝溢れない」という意味を持ち、その名の通り多くの荷物を収納できるバッグです。<br></br>
            持ち手が細いのに非常に丈夫で、重い荷物を入れても安定感があります。サイドストラップを絞れば形を変えられるので、子供の成長に合わせた使い分けも可能です。</p>
          </div>
        </div>
        <div className="mt4 bordered-box">
          <h3><span className="text-border-bottom">現役ママの使い方：ラクサスだからできる「贅沢な使い分け」</span></h3>
          <p>「ゴヤールやエルメスをマザーズバッグにするのは勇気がいるけれど、ラクサスならキズ補償があるからライフスタイルに合わせて活用できる」という声が多数。 また、産後すぐは大容量の「ネヴァーフル GM」、歩き始めたら身軽な「スマホショルダー」へ。子供の成長に合わせてバッグの形を最適化するのが、今どきママの賢い活用術です。</p>
        </div>
      </section>
      <section name="sec5" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/68/8.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>FAQ：育休中の利用に関するよくある質問</h2>
        </div>
        <dl className="faq-item mt4">
          <dt>Q. ブランドバッグの「購入」と「ラクサス」、どちらがお得ですか？</dt>
          <dd>
            <p className="text-font-bolder">A. ライフスタイルが激変する時期は、ラクサスの方が圧倒的に低リスクでお得です。</p>
            <p>数十万円のバッグを購入しても、産後の荷物量や好みの変化で「使いにくい」と感じる失敗は少なくありません。ラクサスなら月額定額制（1日約180円）で、その時々の自分に最適なバッグを自由に交換できます。高額な初期費用を抑えつつ、常に最新かつ最適なモデルを使えるため、育休中の賢い選択として支持されています。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. 産後の荷物が多い時期でも、ラクサスで借りられるバッグは使えますか？</dt>
          <dd>
            <p className="text-font-bolder">A. はい。大容量で収納力のあるトートバッグを多数揃えています。</p>
            <p>おむつや着替え、哺乳瓶などもしっかり入るため、産後の荷物が多い時期でも十分に対応できます。仕切りが少ないデザインが多く、出し入れしやすいのも特徴です。<br></br>
            また、より快適に使いたい場合は、貴重品だけを小さめのバッグに分ける「2個持ち」スタイルも人気です。用途を分けることで、利便性とおしゃれさの両立がしやすくなります。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. 子供がバッグを汚したり、ベビーカーに引っ掛けてキズがついたら？</dt>
          <dd>
            <p className="text-font-bolder">A. 通常の使用に伴うキズや汚れであれば、キズ補償（月額料金内）でカバーされます。</p>
            <p>「子供が触るから高級バッグは持てない」という不安を解消するため、ラクサスではすべてのバッグに補償を適用しています。万が一、日常使いでキズや汚れがついても、お客様に修理費用をご負担いただく必要はありません。公園遊びやベビーカーでのお出かけでも、過度に神経質にならずに憧れのバッグを楽しめます。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. 育休中だけ利用して、すぐに利用を停止（解約）することはできますか？</dt>
          <dd>
            <p className="text-font-bolder">A. はい、契約期間の縛りはないため、いつでも自由に停止・再開が可能です。</p>
            <p>ラクサスには「最低◯ヶ月継続」といったルールはありません。お宮参りや結婚式がある月だけ利用し、予定がない月は「利用停止（月額0円）」に設定することで、育休中の家計に合わせて柔軟に運用できます。アプリ一つで手続きが完結するため、忙しい育児の合間でもスムーズに管理できるのが特徴です。</p>
          </dd>
        </dl>
        <dl className="faq-item mt4">
          <dt>Q. 赤ちゃんが触れることもあるので、衛生面が心配です。</dt>
          <dd>
            <p className="text-font-bolder">A. 専門の鑑定士と職人による、徹底したクリーニングと除菌を実施しています。</p>
            <p>ラクサスでは、すべてのバッグに対して独自のメンテナンスで厳格な検品と清掃を行っています。ウイルス除去に効果のある除菌消臭プロセスを経てからお届けするため、小さなお子様がいるご家庭でも安心してご利用いただけます。百貨店の展示品以上に清潔な状態を保つよう、徹底した品質管理を行っています。</p>
          </dd>
        </dl>
        <div className="border"></div>
        <figure style={{maxWidth: "300px"}}>
          <StaticImage src="../../images/posts/68/9.png" alt=""/>
        </figure>
        <p>「ママ」も「私」も楽しみたいあなたへ。<br></br>
        ラクサスで、今しかできないおしゃれを賢く、自由に楽しみませんか？まずはアプリでお気に入りのバッグをチェックしてみてください。</p>
        <Link to="https://laxus.co" className="view-all-button">ラクサス公式サイトでバッグを見てみる</Link>
      </section>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post68

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 68}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
